import React, { useState } from 'react';
import { CheckCircle2, Gift, BookOpen, Utensils, ShoppingCart, Calendar, Coffee, ShieldCheck, Zap, Globe } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CTAButton } from './CTAButton';
import { useVisitorGeo } from '../hooks/useVisitorGeo';
import { formatVisitorDate } from '../utils/geo';
export function OfferSection() {
  const checkoutUrl = 'https://pay.hotmart.com/F104765975P?checkoutMode=10';
  const geo = useVisitorGeo();
  const todayLabel = formatVisitorDate(geo.timezone);
  const [isOfferExpired, setIsOfferExpired] = useState(() => {
    const storedEndTime = localStorage.getItem('cenas_offer_24h_end_time');
    if (storedEndTime) {
      return new Date().getTime() > parseInt(storedEndTime, 10);
    }
    return false;
  });
  const handleOfferExpire = () => {
    setIsOfferExpired(true);
  };
  return <section id="offer-section" className="py-16 md:py-24 px-4 bg-white relative scroll-mt-10" data-id="element-219" data-mp="2y44af2drgdi4">
      <div className="max-w-4xl mx-auto" data-id="element-220" data-mp="12o1wp6gtb89m">
        <div className="text-center mb-16" data-id="element-221" data-mp="12otffgpb9bih">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-forest mb-4" data-id="element-222" data-mp="xx1xfuk80e3y">
            Todo Lo Que Incluye Tu Protocolo Completo
          </h2>
          <p className="text-lg text-dark/60" data-id="element-223" data-mp="svmdy6xoyfno">
            El stack de transformación nocturna más completo
          </p>
        </div>

        {/* Main Product */}
        <div className="bg-cream p-6 md:p-8 rounded-2xl border-2 border-forest/20 shadow-sm mb-8 relative overflow-hidden" data-id="element-224" data-mp="1ll322sea3ae3">
          <div className="absolute top-0 right-0 bg-forest text-white px-4 py-1 rounded-bl-xl font-bold text-sm" data-id="element-225" data-mp="1go2si7i7zpi8">
            PRODUCTO PRINCIPAL
          </div>
          <div className="flex flex-col md:flex-row gap-6 items-center md:items-start" data-id="element-226" data-mp="17nej5q3rudbo">
            <div className="w-24 h-24 bg-white rounded-xl shadow-sm flex items-center justify-center shrink-0 border border-forest/10" data-id="element-227" data-mp="172hhf1qqdbc">
              <BookOpen size={40} className="text-forest" data-id="element-228" data-mp="3sb9ach1tjswl" />
            </div>
            <div data-id="element-229" data-mp="3tv16amactha5">
              <h3 className="font-serif text-2xl font-bold text-forest mb-2" data-id="element-230" data-mp="3tuixyraf3clv">
                Cenas Anti-Inflamatorias en 15 Minutos — Guía Maestra (PDF)
              </h3>

              <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-dark/80" data-id="element-231" data-mp="3ks9pe6ypltb4">
                <li className="flex items-start gap-2" data-id="element-232" data-mp="3ou52e8q05v4q">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-233" data-mp="3owr8e3x8w2ku" />{' '}
                  El Método de Digestión en Reposo
                </li>
                <li className="flex items-start gap-2" data-id="element-234" data-mp="315ltbqz4pebl">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-235" data-mp="316wtlgtd83xy" />{' '}
                  Los 7 Pilares de la Cena
                </li>
                <li className="flex items-start gap-2" data-id="element-236" data-mp="2s6qn4ew3448a">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-237" data-mp="2x40brsbngbv2" />{' '}
                  El sistema del Plato 50-25-25
                </li>
                <li className="flex items-start gap-2" data-id="element-238" data-mp="28k5iublb9vla">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-239" data-mp="2middudysemtt" />{' '}
                  Los 8 culpables ocultos
                </li>
                <li className="flex items-start gap-2" data-id="element-240" data-mp="2wg9kasgs4tll">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-241" data-mp="2weq5l6aruqlx" />{' '}
                  Guía de especias carminativas
                </li>
                <li className="flex items-start gap-2" data-id="element-242" data-mp="368ffsc68pt5j">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-243" data-mp="318ubrnc7quly" />{' '}
                  Protocolo de Timing Digestivo
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bonuses Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-244" data-mp="18iik775jbj8r">
          {/* Bonus 1 */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-245" data-mp="1dgk5lyqfnune">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-246" data-mp="1i9d9kke2uyyf">
              B1
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-247" data-mp="plhefk45pf3r">
              <Utensils className="text-gold" size={24} data-id="element-248" data-mp="uize0jwaahz3" />
              <h4 className="font-bold text-lg text-forest" data-id="element-249" data-mp="ujiya79epiga">
                Recetario Maestro 21 Cenas
              </h4>
            </div>
            <p className="text-sm text-dark/70 mb-3" data-id="element-250" data-mp="13jp89j5wc0ap">
              21 recetas organizadas en 4 categorías (Mar, Aves, Vegetales,
              Huevo). Máximo 15 minutos.
            </p>
            <ul className="text-sm text-dark/80 space-y-1" data-id="element-251" data-mp="2ez42if6q0e24">
              <li className="flex items-center gap-2" data-id="element-252" data-mp="2exj6sm8o6p2o">
                <CheckCircle2 size={14} className="text-success" data-id="element-253" data-mp="2p3khl6cdlr4v" /> Lista de
                ingredientes exacta
              </li>
              <li className="flex items-center gap-2" data-id="element-254" data-mp="2k597cui65em4">
                <CheckCircle2 size={14} className="text-success" data-id="element-255" data-mp="2fd7wnd0nfvy7" /> Pasos con
                tiempos reales
              </li>
              <li className="flex items-center gap-2" data-id="element-256" data-mp="2bcfnskvovt2g">
                <CheckCircle2 size={14} className="text-success" data-id="element-257" data-mp="2b9ti6qscznmv" /> Variante
                rápida de emergencia
              </li>
            </ul>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-258" data-mp="21fjdqaq56yvs">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-259" data-mp="1wen8ntu216os">
              B2
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-260" data-mp="3qrv1jfygz87s">
              <ShoppingCart className="text-gold" size={24} data-id="element-261" data-mp="3mqji5s66vj81" />
              <h4 className="font-bold text-lg text-forest" data-id="element-262" data-mp="3moynm2jvk0a6">
                Checklist de Despensa
              </h4>
            </div>
            <p className="text-sm text-dark/70 mb-3" data-id="element-263" data-mp="1ovdyhydq53yo">
              Tu mapa de compras definitivo para una cocina anti-inflamatoria.
            </p>
            <ul className="text-sm text-dark/80 space-y-1" data-id="element-264" data-mp="1b5aihp5fu6ho">
              <li className="flex items-center gap-2" data-id="element-265" data-mp="1f62vmthfkvj8">
                <CheckCircle2 size={14} className="text-success" data-id="element-266" data-mp="1f2ovlrw8oyey" /> Qué eliminar
                hoy mismo
              </li>
              <li className="flex items-center gap-2" data-id="element-267" data-mp="27u8hxko4usl6">
                <CheckCircle2 size={14} className="text-success" data-id="element-268" data-mp="27rmarm55mf3h" /> 25
                ingredientes básicos
              </li>
              <li className="flex items-center gap-2" data-id="element-269" data-mp="1yt0iv0dslnq1">
                <CheckCircle2 size={14} className="text-success" data-id="element-270" data-mp="1yrh1f6geh6mo" /> Guía de
                etiquetado en súper
              </li>
            </ul>
          </div>

          {/* Bonus 3 */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-271" data-mp="nen029xwbygv">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-272" data-mp="evti8palft2i">
              B3
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-273" data-mp="ovahanvcb8pi">
              <Calendar className="text-gold" size={24} data-id="element-274" data-mp="osoawrk6qz8v" />
              <h4 className="font-bold text-lg text-forest" data-id="element-275" data-mp="jx8z055qndf3">
                Planificador Semanal
              </h4>
            </div>
            <ul className="text-sm text-dark/80 space-y-1 mt-2" data-id="element-276" data-mp="3s9enjpa9wajj">
              <li className="flex items-center gap-2" data-id="element-277" data-mp="3ne93yx4cf7ym">
                <CheckCircle2 size={14} className="text-success" data-id="element-278" data-mp="5vwoi99ck40l" /> Plantilla de
                7 días imprimible
              </li>
              <li className="flex items-center gap-2" data-id="element-279" data-mp="14obz4cq02j7">
                <CheckCircle2 size={14} className="text-success" data-id="element-280" data-mp="39l9ogv4k9dr2" /> Seguimiento
                de síntomas
              </li>
              <li className="flex items-center gap-2" data-id="element-281" data-mp="34myg6otwzbay">
                <CheckCircle2 size={14} className="text-success" data-id="element-282" data-mp="34kc90qaxqxt9" /> Escala de
                inflamación matutina
              </li>
            </ul>
          </div>

          {/* Bonus 4 & 5 Combined */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-283" data-mp="2o3rnj22kyoku">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-284" data-mp="2t3e2bfy24cvr">
              B4+5
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-285" data-mp="31zn2wxxrthjh">
              <Coffee className="text-gold" size={24} data-id="element-286" data-mp="36zr99v4ysvvz" />
              <h4 className="font-bold text-lg text-forest" data-id="element-287" data-mp="3brj108zux7np">
                Infusiones & Ritual
              </h4>
            </div>
            <ul className="text-sm text-dark/80 space-y-1 mt-2" data-id="element-288" data-mp="3gqvo8uun4gqt">
              <li className="flex items-center gap-2" data-id="element-289" data-mp="3lpp24odua9ri">
                <CheckCircle2 size={14} className="text-success" data-id="element-290" data-mp="3lr07gsmxnpkq" /> 5 infusiones
                post-cena eficaces
              </li>
              <li className="flex items-center gap-2" data-id="element-291" data-mp="3poxtxnpbjxkf">
                <CheckCircle2 size={14} className="text-success" data-id="element-292" data-mp="1e4qa02gj3vi4" /> Ritual de
                cierre de 30 min
              </li>
              <li className="flex items-center gap-2" data-id="element-293" data-mp="1a124dpbgj9zi">
                <CheckCircle2 size={14} className="text-success" data-id="element-294" data-mp="152h2llgk4i8y" /> Respiración
                4-7-8 anti-cortisol
              </li>
            </ul>
          </div>
        </div>

        {/* SUPER LLAMATIVA OFFER STACK */}
        <div id="offer-stack" className="bg-forest rounded-3xl p-1 shadow-2xl relative overflow-hidden mt-20 scroll-mt-6" data-id="element-295" data-mp="1xqmpadr68hbf">
          <div className="absolute inset-0 bg-gradient-to-r from-gold via-white to-gold opacity-30 animate-[spin_4s_linear_infinite] scale-150" data-id="element-296" data-mp="1o1uyi8xuk323"></div>

          <div className="bg-cream rounded-[22px] p-6 md:p-10 relative z-10" data-id="element-297" data-mp="1j2ic1paw0y01">
            <div className="text-center mb-8" data-id="element-298" data-mp="2gjh1izxetvby">
              <h3 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-2" data-id="element-299" data-mp="2gk8pbokrmoro">
                Resumen de tu Inversión
              </h3>
              <p className="text-dark/60" data-id="element-300" data-mp="3vhvni0angrwz">Todo lo que te llevas hoy</p>
            </div>

            <div className="space-y-3 mb-8 max-w-lg mx-auto" data-id="element-301" data-mp="3qij4xrqta707">
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-302" data-mp="3qk3v7563f3s9">
                <span className="text-dark/80 font-medium" data-id="element-303" data-mp="979nyd17zi4l">
                  Guía Maestra Anti-Inflamatoria
                </span>
                <span className="text-dark/50 line-through" data-id="element-304" data-mp="i9iuysxa4td8">$53 USD</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-305" data-mp="dbr5s6o0rlcq">
                <span className="text-dark/80 font-medium" data-id="element-306" data-mp="s0n9xsmyge82">
                  Recetario Maestro 21 Cenas
                </span>
                <span className="text-dark/50 line-through" data-id="element-307" data-mp="n2c0hj0ko5qd">$31 USD</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-308" data-mp="111tss8d2u14h">
                <span className="text-dark/80 font-medium" data-id="element-309" data-mp="x087pzqe2gj7">
                  Checklist Despensa
                </span>
                <span className="text-dark/50 line-through" data-id="element-310" data-mp="1fo0l4ij4ofo6">$19 USD</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-311" data-mp="1km2473gk0ezn">
                <span className="text-dark/80 font-medium" data-id="element-312" data-mp="16m16fwvl5noe">
                  Planificador Semanal
                </span>
                <span className="text-dark/50 line-through" data-id="element-313" data-mp="1bo09f5neyikt">$14 USD</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-314" data-mp="wvomo6vlhyjb">
                <span className="text-dark/80 font-medium" data-id="element-315" data-mp="11p0z7in02evp">
                  Guía de Infusiones
                </span>
                <span className="text-dark/50 line-through" data-id="element-316" data-mp="nui2nntqm5lb">$19 USD</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-317" data-mp="rvk3g93ayppe">
                <span className="text-dark/80 font-medium" data-id="element-318" data-mp="e0875x9i0r6d">
                  Ritual de Cierre 30 Minutos
                </span>
                <span className="text-dark/50 line-through" data-id="element-319" data-mp="2km5pap226ue3">$19 USD</span>
              </div>
              <div className="flex justify-between items-center pt-2" data-id="element-320" data-mp="2fvxmsrasw40a">
                <span className="text-forest font-bold text-lg" data-id="element-321" data-mp="2ftkvhnj5khak">
                  VALOR TOTAL REAL:
                </span>
                <span className="text-urgency font-bold text-xl line-through" data-id="element-322" data-mp="26v977s5rdvla">
                  $155 USD
                </span>
              </div>
            </div>

            {/* PRICING BOX — SINGLE PHASE */}
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border-2 border-gold text-center relative" data-id="element-323" data-mp="2zj53ivrf1lhj">
              <p className="text-dark/70 font-medium mb-2 mt-2" data-id="element-324" data-mp="2ujinyfo47t5k">
                Precio Especial Por Tiempo Limitado:
              </p>

              <div className="flex flex-col items-center gap-1 mb-6" data-id="element-325" data-mp="2pl8ovtz9s8eo">
                <div className="flex items-center gap-3" data-id="element-326" data-mp="1j67uhspw7ya7">
                  <span className="text-lg text-dark/30 line-through font-medium" data-id="element-327" data-mp="1e6lghh28qe0c">
                    Valor real: $155 USD
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-328" data-mp="140aghblbd8ti">
                  <span className="text-2xl text-dark/40 line-through font-bold" data-id="element-329" data-mp="192jcyhxeat0d">
                    Precio regular: $32.90 USD
                  </span>
                </div>
                <div className="flex flex-col items-center gap-0.5 mt-3 mb-1" data-id="element-330" data-mp="1ir1amqadojzs">
                  <span className="text-sm md:text-base text-urgency font-bold uppercase tracking-wide leading-tight" data-id="element-331" data-mp="1it44xmikczab">
                    Oportunidad única en esta página solo hoy
                  </span>
                  <span className="text-sm font-semibold text-forest" data-id="element-332" data-mp="1wr2i4ol5epo8">
                    {todayLabel}
                  </span>
                </div>
                <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" aria-label="Comprar ahora por 15.90 dólares" className="text-6xl md:text-7xl font-serif font-bold text-success drop-shadow-sm rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2" data-id="element-333" data-mp="21oudxtowyvxp">
                  $15.90 <span className="text-2xl text-success/70" data-id="element-334" data-mp="1swhm6dvrlthb">USD</span>
                </a>
              </div>

              <div className="bg-forest/5 rounded-xl p-4 mb-8 text-sm text-dark/80 flex items-center justify-center gap-2" data-id="element-335" data-mp="21utm56iiu3mf">
                <Gift size={18} className="text-gold" data-id="element-336" data-mp="1e4qtopap2vna" />
                <span data-id="element-337" data-mp="1e364lf75g4wt">
                  Incluye derecho a{' '}
                  <strong data-id="element-338" data-mp="1a4ykcadh8lgv">recibir todas las actualizaciones futuras</strong>{' '}
                  gratis.
                </span>
              </div>

              {!isOfferExpired && <CountdownTimer theme="light" className="mb-8" storageKey="cenas_offer_24h_end_time" durationMs={24 * 60 * 60 * 1000} onExpire={handleOfferExpire} data-id="element-339" data-mp="1j3akp445axmi" />}

              <CTAButton text="SÍ, QUIERO DESINFLAMARME HOY" href={checkoutUrl} variant="urgency" className="text-xl md:text-2xl py-5" showTrust={false} data-id="element-340" data-mp="322i00scj928k" />

              <p className="text-xs text-dark/60 mt-4 max-w-md mx-auto leading-relaxed flex items-start justify-center gap-1.5 text-left sm:text-center" data-id="element-341" data-mp="2t466ahgddobw">
                <Globe size={14} className="text-dark/60 shrink-0 mt-0.5" aria-hidden="true" data-id="element-342" data-mp="3lqr1jszyukkq" />
                <span data-id="element-343" data-mp="3bstdp6m0qpsn">
                  En la próxima página de pago podrás pagar en tu moneda local y
                  verás la conversión automática del precio.
                </span>
              </p>

              <div className="mt-4 mx-auto max-w-xs h-px bg-forest/10" role="presentation" data-id="element-344" data-mp="20dnzp6gft4tq" />

              <p className="text-xs text-dark/50 mt-4" data-id="element-345" data-mp="25dshr0wzu7m2">
                Acceso inmediato • Descarga instantánea • Garantía 30 días
              </p>

              {/* Mercado Pago */}
              <div className="mt-6 pt-6 border-t border-forest/10 flex flex-col items-center gap-2" data-id="element-346" data-mp="1h8svt5ylzuiq">
                <p className="text-xs text-dark/60 font-medium" data-id="element-347" data-mp="1chja2gg6lbc4">
                  Pago disponible con
                </p>
                <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" aria-label="Comprar ahora con Mercado Pago" className="rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2" data-id="element-348" data-mp="17iq3l7zbaklg">
                  <img src="https://cdn.magicpatterns.com/uploads/qhpGf2YGATQAhMnp28H3Ro/Mercado_Pago.svg.png" alt="Mercado Pago" className="h-16 sm:h-[4.5rem] w-auto object-contain" data-id="element-349" data-mp="oknbulfdq9jy" />
                </a>
              </div>

              {/* Trust badges */}
              <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-350" data-mp="2qh4ise38wxyc">
                <div className="flex items-center gap-2 text-sm text-dark/80 font-medium" data-id="element-351" data-mp="2vffter1d7chm">
                  <div className="bg-success/10 p-2 rounded-full" data-id="element-352" data-mp="3091y9x1aec2v">
                    <ShieldCheck size={18} className="text-success" data-id="element-353" data-mp="357bpxxnsyujq" />
                  </div>
                  <span data-id="element-354" data-mp="27jl6n1lhqz7p">Garantía 30 días</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-dark/80 font-medium" data-id="element-355" data-mp="27leeulbr5rht">
                  <div className="bg-forest/10 p-2 rounded-full" data-id="element-356" data-mp="2ck8vphq5t5za">
                    <Zap size={18} className="text-forest" data-id="element-357" data-mp="2hgg37ey7epjc" />
                  </div>
                  <span data-id="element-358" data-mp="2lj2xrnm9eok8">Acceso inmediato post-pago</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}